import React from 'react';

interface FAQ {
    question: string;
    answer: string;
    userTypes?: string[]; // Optional array of target audiences
}

const FAQSection: React.FC = () => {
    const faqs: FAQ[] = [
        {
            question: 'Can CGM integrate with the technology our athletes are already using?',
            answer: 'Yes. CGM connects with common wearables your athletes already use, such as WHOOP, Garmin, Oura, Apple Watch, and others. We unify everything into one platform so coaches and staff can review simple, reliable trends without asking athletes to change their routines.',
            userTypes: ['Head Coaches']
        },
        {
            question: 'Does CGM replace our existing testing or sport science workflows?',
            answer: 'No. CGM is built to support and streamline your existing workflow. You can continue using your current testing protocols, GPS systems, and wellness questionnaires. CGM simply consolidates the data and helps you use it as a more efficient briefing tool when communicating with your coaches.',
            userTypes: ['S&C Staff']
        },
        {
            question: 'How does CGM fit into a clinical environment without adding more admin work?',
            answer: 'CGM automatically imports data from your clients’ wearables and organizes it into clear recovery, readiness, and progress trends. Clinicians can quickly reference these signals during sessions or for hybrid care without changing documentation workflows or adding new software to manage.',
            userTypes: ['Out-of-Network', 'Hybrid PT Clinics']
        },
        {
            question: 'Can CGM be deployed across multiple coaches, locations, or classes?',
            answer: 'Yes. Our platform supports multi-coach teams and multi-location gyms. You can standardize your programs, track client engagement and progress, and give members a higher-end performance experience that is consistent across all coaches or franchise locations.',
            userTypes: ['Gyms and Trainers at Franchises']
        },
    ];

    return (
        <section className="pb-36 px-4 sm:px-6 lg:px-8 bg-black relative">
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white/10 to-transparent pointer-events-none"></div>
            <div className="max-w-4xl mx-auto relative z-10">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center observe-fade opacity-0">Have a question?</h2>
                <p className="text-gray-300 text-center mb-12 observe-fade opacity-0">
                    Simply contact us through our website and we wll schedule a consultation to help support your organization. 
                </p>
                <div className="space-y-6">
                    {faqs.map((faq, index) => (
                        <div key={index} className="bg-neutral-900 rounded-xl p-6 observe-fade opacity-0 border border-neutral-800">
                            {faq.userTypes && faq.userTypes.length > 0 && (
                                <div className="flex flex-wrap gap-2 mb-4">
                                    {faq.userTypes.map((userType, idx) => (
                                        <span 
                                            key={idx}
                                            className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-purple-500/10 text-purple-400 border border-purple-500/20"
                                        >
                                            {userType}
                                        </span>
                                    ))}
                                </div>
                            )}
                            <h3 className="text-xl font-bold text-white mb-3">{faq.question}</h3>
                            <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;

